<template>
  <div class="rightEvent_main-div" ref="doctorAdvice">
    <p class="main_title-p">添加事件</p>
    <div class="main_body-div">
      <div
        class="body_container-div"
        v-for="(item, index) in list"
        :key="index"
      >
        <!-- 事件选择 -->
        <div class="left-div">
          <div class="page-title-div-select">
            <a-select style="width: 100%" placeholder="事件类型">
              <a-select-option
                :value="e.id"
                v-for="e in eventMethods"
                :key="e.id"
              >
                {{ e.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="page-title-div-img"></div>
        </div>
        <!-- 数据名选择 -->
        <div class="right-div">
          <div class="page-title-div-select" ref="doctorAdvice">
            <a-select
              style="width: 100%"
              placeholder="请选择数据交互"
              v-show="!item.inputStatus"
            >
              <a-select-option
                :value="dn.id"
                v-for="dn in dataName"
                :key="dn.id"
              >
                {{ dn.name }}
              </a-select-option>
            </a-select>
            <!-- <a-input
              :prefix="prefix"
              :suffix="suffix"
              v-show="item.inputStatus"
            /> -->
          </div>
          <div class="page-title-div-img"></div>
        </div>
        <!-- 控制图标 -->
        <div class="icon-div">
          <img
            :src="item.inputStatus ? jsActiveImg : jsImg"
            alt="错误"
            @click="clickJSImg(item)"
          />
          <img :src="emptyImg" alt="错误" @click="del(index)" />
        </div>
      </div>
      <div class="body_btn-div">
        <a-button
          class="btn_style"
          type="dashed"
          icon="plus"
          @click="addData"
        ></a-button>
      </div>
      <a-button @click="setComponent">保存</a-button>
    </div>
  </div>
</template>

<script>
import BlockComponent from "@/utils/BlockComponent.js";
import bus from "@/utils/Bus";
import _ from "lodash";
export default {
  name: "RightEvent",
  props: {
    component: {
      type: Object,
      default: new BlockComponent(),
    },
  },
  data() {
    return {
      note: {},
      prefix: "{{",
      suffix: "}}",
      jsActiveImg: require("@/assets/edit-page/js.png"),
      jsImg: require("@/assets/edit-page/js-c.png"),
      emptyActiveImg: require("@/assets/edit-page/empty.png"),
      emptyImg: require("@/assets/edit-page/empty-d.png"),
      list: [
        {
          inputStatus: false,
        },
      ],
      clickIndex: -1,
      eventMethods: [
        {
          // v-for里套v-for ,注意重复key的问题
          id: 123301,
          name: "onClick",
        },
        {
          id: 123302,
          name: "onChange",
        },
      ],
      dataName: [
        {
          id: 123303,
          name: "数据名称",
        },
        {
          id: 123304,
          name: "数据名称2",
        },
      ],
    };
  },
  watch: {
    component: {
      handler(component) {
        console.log(`事件面板监听到props component 变化: `, component.note);
        this.note = _.cloneDeep(component.note);
      },
      deep: true,
    },
  },
  methods: {
    setComponent() {
      bus.$emit("update-component-note", this.note);
    },
    /**
     * @name 增加事件
     * @description 模拟数据添加
     */
    addData() {
      this.list.push({
        inputStatus: false,
      });
    },
    /**
     * @name 删除事件
     */
    del(index) {
      this.list.splice(index, 1);
    },
    clickJSImg(item){
      item.inputStatus = !item.inputStatus;
      bus.$emit("code-drawer",true);
    }
  },
};
</script>

<style scoped>
@import url("./index.css");
</style>